import AddressSimpleView from './AddressSimpleView'
export default AddressSimpleView
